class HomeArticle extends HTMLElement {
    constructor() {
        super();
    }
    connectedCallback() {
        this.init();
    }
    init() {
        this.setup()
        this.interact()
    }
    setup() {
        new MasterTimeline({
            triggerInit: this,
            scrollTrigger: { trigger: this, start: 'top top+=70%' },
            tweenArr: [
                new RevealText({ el: this.querySelector('.home-article-label .txt'), color: '#787878', isFast: true }),
                new RevealTextReset({ el: this.querySelector('.home-article-title .txt'), color: 'black' }),
                new ScaleInset({ el: this.querySelectorAll('.home-article-thumb-item')[0], delay: "<=0" }),
            ]
        })
        document.querySelectorAll('.home-article-list-item').forEach((item, index) => {
            new MasterTimeline({
                triggerInit: this,
                scrollTrigger: { trigger: item },
                tweenArr: [
                    new ScaleLine({ el: item.querySelector('.div-line.top') }),
                    new FadeSplitText({ el: item.querySelector('.home-article-list-item-order .txt') }),
                    new FadeSplitText({ el: item.querySelector('.home-article-list-item-title .txt'), delay: "<=0" }),
                    ...Array.from(item.querySelectorAll('.home-article-list-item-info-item')).flatMap((info) => {
                        return [
                            new FadeIn({ el: info.querySelector('.home-article-list-item-info-item-ic') }),
                            new FadeSplitText({ el: info.querySelector('.home-article-list-item-info-item-txt .txt'), delay: "<=0" })
                        ]
                    }),
                    new FadeSplitText({ el: item.querySelector('.home-article-list-item-sub .txt') }),
                    new ScaleLine({ el: item.querySelector('.div-line.bot') }),
                    index === document.querySelectorAll('.home-article-list-item').length - 1 && new FadeIn({ el: this.querySelector('.home-article-btn'), from: { y: parseRem(20) }, delay: "<=.2" })
                ],
            })
        })
    }
    interact() {
        let allItems = this.querySelectorAll('.home-article-list-item');
        let allThumbs = this.querySelectorAll('.home-article-thumb-item');
        allItems.forEach((item, index) => {
            item.addEventListener('mouseenter', () => {
                allItems.forEach((item, index) => {
                    item.classList.remove('active');
                });
                item.classList.add('active');
                gsap.set('.home-article-thumb-inner', {yPercent: -100 / allItems.length * index});
                gsap.set('.home-article-thumb-wrap', {y: allItems[index].offsetTop});
            });
        });
    }
}
customElements.define('home-article', HomeArticle);